// removed by extract-text-webpack-plugin
module.exports = {"DrawerToggle":"DrawerToogle__DrawerToggle__J7uhY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/DrawerToogle/DrawerToogle.css
// module id = 98
// module chunks = 2